<template>
 <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
  <validation-observer ref="observer">
    <v-card>
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>

      <v-col cols="12" md="12">
        <p class="text-md-caption">
          To be completed by the Extended Services (ES) representative. This
          form confirms that this individual has funding available for long term
          support once the individual reaches 20 percent or less coaching
          intervention OR 24 months on the job.
        </p>
      </v-col>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span>CLIENT INFORMATION </span>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Client Name"
              v-model="item.employeeName"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Address" v-model="item.address"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="City" v-model="item.city"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field label="State" v-model="item.state"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field label="Zip" v-model="item.zip"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field label="Phone" v-model="item.phone"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Date of Birth"
              v-model="item.birthDate"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p class="text-md-caption">
              To be completed by the Extended Services (ES) representative. This
              form confirms that this individual has funding available for long
              term support once the individual reaches 20 percent or less
              coaching intervention OR 24 months on the job.
            </p>
          </v-col>

          <v-col cols="2">
            <v-checkbox
              class="text-caption"
              label="DSPD"
              v-model="isChkDSPD"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              class="text-caption"
              label="DSAMH "
              v-model="isChkDSAMH"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              class="text-caption"
              label="Natural Supports "
              v-model="isChkNaturalSupports"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              class="text-caption"
              label="TTW "
              v-model="item.isChkTTW"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              class="text-caption"
              label="Private Pay "
              v-model="isChkPrivatePay"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span
          >SECTION 1: To Be Completed for clients eligible for DSPD supports:
          Division of Services for People with Disabilities (DSPD) Information
          (if applicable)
        </span>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <span class="text-md-caption">
              <b>Status with DSPD:</b>
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-n8">
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Waitlist (Support Work Independence Funds) "
              v-model="isChkWaitlist"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Applicant with DSPD "
              v-model="isChkApplicantDSPD"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Waiver (Medicaid Funds) "
              v-model="isChkWaiver"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Not eligible for support with DSPD "
              v-model="isChkNotEligible"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" class="mt-n11 ml-1">
            <span class="text-md-caption">
              <b>Note: </b>Waitlist clients have a SWI worker assigned while the
              Waiver clients have a Support Coordinator assigned.
            </span>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <span class="text-md-caption">
              <b>Reported DSPD Functional Limitations:</b> (Check all that
              apply)
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col cols="12" md="12">
            <v-row class="mt-n13">
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Activities of Daily Life"
                  v-model="isChkActivities"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Communication"
                  v-model="isChkCommunication"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Economic Self-Sufficiency"
                  v-model="isChkEconomic"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Judgment and Self Protection"
                  v-model="isChkJudgement"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Memory or Cognition"
                  v-model="isChkMemory"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Physical Health"
                  v-model="isChkPhysical"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Self-Care"
                  v-model="isChkSelfCare"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Capacity for Independent Living"
                  v-model="isChkCapacity"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Control of Emotion"
                  v-model="isChkControl"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Employment"
                  v-model="isChkEmployment"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Learning"
                  v-model="isChkLearning"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Mobility"
                  v-model="isChkMobility"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Receptive and Expressive Language"
                  v-model="isChkReceptive"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  class="text-caption"
                  label="Self-Direction"
                  v-model="isChkSelfDirection"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <span class="text-md-caption">
              <b>Services receiving from DSPD</b> (For description of services
              go to www.dspd.utah.gov) (Check all that apply)
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-n8">
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Behavioral "
              v-model="isChkBehavioral"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Day Program "
              v-model="isChkDayProgram"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Supported Employment "
              v-model="isChkSupported"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox
              class="text-caption"
              label="Transportation "
              v-model="isChkTransportation"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="12">
            <v-checkbox
              class="text-caption"
              label="Facility-Based Work (sheltered workshop-client is receiving sub-minimum wages) "
              v-model="isChkFacilityBasedWork"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="12">
            <v-checkbox
              class="text-caption"
              label="In Home. If yes, provider info"
              v-model="isChkInHome"
            ></v-checkbox>
            <v-expand-transition>
              <v-col cols="12" v-if="isChkInHome">
                <v-row>
                  <v-col cols="12">
                    <v-expand-transition>
                      <v-textarea
                        auto-grow
                        outlined
                        label="Provider Info"
                        v-model="providerInfo"
                      ></v-textarea>
                    </v-expand-transition>
                  </v-col>
                </v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        class="text-caption"
                        label="Respite"
                        v-model="isChkRespite"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        class="text-caption"
                        label="Family Support "
                        v-model="isChkFamilySupport"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        class="text-caption"
                        label="Supported Living "
                        v-model="isChkSupportedHomeLiving"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        class="text-caption"
                        label="After School"
                        v-model="isChkAfterSchool"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-expand-transition>
          </v-col>
          <v-col cols="12" md="12">
            <v-checkbox
              class="text-caption"
              label="Residential. If yes, residential info"
              v-model="isChkResidential"
            ></v-checkbox>
            <v-expand-transition>
              <v-col cols="12" v-if="isChkResidential">
                <v-row>
                  <v-col cols="12">
                    <v-expand-transition>
                      <v-textarea
                        auto-grow
                        outlined
                        label="Residential Info"
                        v-model="residentialInfo"
                      ></v-textarea>
                    </v-expand-transition>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-checkbox
                      class="text-caption"
                      label="24 hour Residential"
                      v-model="isChk24Hour"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox
                      class="text-caption"
                      label="Professional Parent"
                      v-model="isChkProfessionalParent"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox
                      class="text-caption"
                      label="Supported Living "
                      v-model="isChkSupportedResidentialLiving"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-expand-transition>
          </v-col>
          <v-col cols="12" md="12">
            <v-checkbox
              class="text-caption"
              label="Other: Specify:"
              v-model="isChkOther"
            ></v-checkbox>
            <v-col cols="12">
              <v-expand-transition>
                <v-textarea
                  v-if="isChkOther"
                  auto-grow
                  outlined
                  label="Specify"
                  v-model="specify"
                ></v-textarea>
              </v-expand-transition>
            </v-col>
          </v-col>
        </v-row>
      </v-col>

      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <span class="text-md-caption">
              Signature of DSPD Representative Verifying Ongoing Funding:
            </span>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Signature"
                @click.stop="updateSignature('dspd')"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="dspdRepresentativeSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="dspdDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dspdRepresentativeDate"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dspdRepresentativeDate"
                @input="dspdDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Title of Representative"
              v-model="dspdTitle"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <span class="text-md-caption">
              Contact Information of Representative:
            </span>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Email" v-model="dspdEmail"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Phone" v-model="dspdPhone"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span
          >SECTION 2: To be completed for clients eligible for Individual
          Placement and Support: Division of Substance Abuse and Mental Health
          Information (DSAMH) (if applicable) or Other Funding Support (natural
          support, private pay, SSA work incentive, etc):
        </span>
      </v-col>

      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-col cols="12" md="12">
              <v-textarea
                auto-grow
                outlined
                label="Individual Placement and Support Provider or OTHER Support Provider:"
                v-model="otherSupportProvider"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="extendedSupports"
                auto-grow
                outlined
                label="Extended supports available:"
              ></v-textarea>
            </v-col>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Signature of IPS Representative:"
                @click.stop="updateSignature('ips')"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="ipsSignature"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="ipsDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.ipsDate"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.ipsDate"
                @input="ipsDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Title of Representative:"
              v-model="ipsRepresentative"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Email" v-model="ipsEmail"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="Phone" v-model="ipsPhone"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span>SECTION 3: To be completed by DSPD or DSAMH/IPS Provider: </span>
      </v-col>
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6">
            <v-radio-group row v-model="rbIsChkVia">
              <span class="mr-3">Form sent via: </span>
              <v-radio label="Fax" :value="true"></v-radio>
              <v-radio label="Email" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              label="To VR Counselor name:"
              v-model="vrCounselorName"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Email"
              v-model="providerEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Phone"
              v-model="providerPhone"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field label="Fax" v-model="providerFax"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateSentMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSent"
                  label="Date Sent"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSent"
                @input="dateSentMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </validation-observer>
</div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import download from "downloadjs";

export default {
  components: { ValidationProvider, ValidationObserver },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      showSignaturePad: false,
      dspdDateMenu: false,
      ipsDateMenu: false,
      dateSentMenu: false,
      userID: localStorage.getItem("userID"),
      selectedLimitation: [],
      item: {},
      step: this.currentStep,
      isChkDSPD: "",
      isChkDSAMH: "",
      isChkNaturalSupports: "",
      isChkTTW: "",
      isChkPrivatePay: "",
      isChkWaitlist: "",
      isChkApplicantDSPD: "",
      isChkWaiver: "",
      isChkNotEligible: "",
      isChkActivities: "",
      isChkCommunication: "",
      isChkEconomic: "",
      isChkJudgement:"",
      isChkMemory:"",
      isChkPhysical:"",
      isChkSelfCare:"",
      isChkCapacity:"",
      isChkControl:"",
      isChkEmployment:"",
      isChkLearning:"",
      isChkMobility:"",
      isChkReceptive:"",
      isChkSelfDirection:"",
      isChkBehavioral:"",
      isChkDayProgram: "",
      isChkSupported:"",
      isChkTransportation:"",
      isChkFacilityBasedWork:"",
      isChkInHome:"",
      providerInfo:"",
      isChkRespite:"",
      isChkFamilySupport:"",
      isChkSupportedHomeLiving:"",
      isChkAfterSchool:"",
      isChkResidential:"",
      residentialInfo:"",
      isChk24Hour:"",
      isChkProfessionalParent:"",
      isChkSupportedResidentialLiving:"",
      isChkOther:"",
      specify:"",
      dspdTitle:"",
      dspdEmail:"",
      dspdPhone:"",
      otherSupportProvider:"",
      extendedSupports:"",
      ipsRepresentative:"",
      ipsEmail:"",
      ipsPhone:"",
      rbIsChkVia:"",
      vrCounselorName:"",
      providerEmail:"",
      providerPhone:"",
      providerFax:"",
    };
  },

  created() {
    this.populateUserInfo();
    const savedDspdSignature = localStorage.getItem("dspdRepresentativeSignature");
    const savedIpsSignature = localStorage.getItem("ipsSignature");

    if (savedDspdSignature) {
      this.dspdRepresentativeSignature = savedDspdSignature;
    }

    if (savedIpsSignature) {
      this.ipsSignature = savedIpsSignature;
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step+1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    updateSignature(signer) {
        this.currentSigner = signer; // Store which signer's signature is being updated
        this.showSignaturePad = true;
    },

    signatureData(data) {
        if (this.currentSigner === 'dspd') {
            this.dspdRepresentativeSignature = data;
            localStorage.setItem("dspdRepresentativeSignature", data);
        } else if (this.currentSigner === 'ips') {
            this.ipsSignature = data;
            localStorage.setItem("ipsSignature", data);
        }
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: this.item,
          pdfDocument: "confirmation-extended-service",
          employeeID: this.user._id,
        });
        console.log(response);
        localStorage.setItem('isChkDSPD', this.isChkDSPD);
        localStorage.setItem('isChkDSAMH', this.isChkDSAMH);
        localStorage.setItem('isChkNaturalSupports', this.isChkNaturalSupports);
        localStorage.setItem('isChkTTW', this.isChkTTW);
        localStorage.setItem('isChkPrivatePay', this.isChkPrivatePay);
        localStorage.setItem('isChkWaitlist', this.isChkWaitlist);
        localStorage.setItem('isChkApplicantDSPD', this.isChkApplicantDSPD);
        localStorage.setItem('isChkWaiver', this.isChkWaiver);
        localStorage.setItem('isChkNotEligible', this.isChkNotEligible);
        localStorage.setItem('isChkActivities', this.isChkActivities);
        localStorage.setItem('isChkCommunication', this.isChkCommunication);
        localStorage.setItem('isChkEconomic', this.isChkEconomic);
        localStorage.setItem('isChkJudgement', this.isChkJudgement);
        localStorage.setItem('isChkMemory', this.isChkMemory);
        localStorage.setItem('isChkPhysical', this.isChkPhysical);
        localStorage.setItem('isChkSelfCare', this.isChkSelfCare);
        localStorage.setItem('isChkCapacity', this.isChkCapacity);
        localStorage.setItem('isChkControl', this.isChkControl);
        localStorage.setItem('isChkEmployment', this.isChkEmployment);
        localStorage.setItem('isChkLearning', this.isChkLearning);
        localStorage.setItem('isChkMobility', this.isChkMobility);
        localStorage.setItem('isChkReceptive', this.isChkReceptive);
        localStorage.setItem('isChkSelfDirection', this.isChkSelfDirection);
        localStorage.setItem('isChkBehavioral', this.isChkBehavioral);
        localStorage.setItem('isChkDayProgram', this.isChkDayProgram);
        localStorage.setItem('isChkSupported', this.isChkSupported);
        localStorage.setItem('isChkTransportation', this.isChkTransportation);
        localStorage.setItem('isChkFacilityBasedWork', this.isChkFacilityBasedWork);
        localStorage.setItem('isChkInHome', this.isChkInHome);
        localStorage.setItem('providerInfo', this.providerInfo);
        localStorage.setItem('isChkRespite', this.isChkRespite);
        localStorage.setItem('isChkFamilySupport', this.isChkFamilySupport);
        localStorage.setItem('isChkSupportedHomeLiving', this.isChkSupportedHomeLiving);
        localStorage.setItem('isChkAfterSchool', this.isChkAfterSchool);
        localStorage.setItem('isChkResidential', this.isChkResidential);
        localStorage.setItem('residentialInfo', this.residentialInfo);
        localStorage.setItem('isChk24Hour', this.isChk24Hour);
        localStorage.setItem('isChkProfessionalParent', this.isChkProfessionalParent);
        localStorage.setItem('isChkSupportedResidentialLiving', this.isChkSupportedResidentialLiving);
        localStorage.setItem('isChkOther', this.isChkOther);
        localStorage.setItem('specify', this.specify);
        localStorage.setItem('dspdTitle', this.dspdTitle);
        localStorage.setItem('dspdEmail', this.dspdEmail);
        localStorage.setItem('dspdPhone', this.dspdPhone);
        localStorage.setItem('otherSupportProvider', this.otherSupportProvider);
        localStorage.setItem('extendedSupports', this.extendedSupports);
        localStorage.setItem('ipsRepresentative', this.ipsRepresentative);
        localStorage.setItem('ipsEmail', this.ipsEmail);
        localStorage.setItem('ipsPhone', this.ipsPhone);
        localStorage.setItem('rbIsChkVia', this.rbIsChkVia);
        localStorage.setItem('vrCounselorName', this.vrCounselorName);
        localStorage.setItem('providerEmail', this.providerEmail);
        localStorage.setItem('providerPhone', this.providerPhone);
        localStorage.setItem('providerFax', this.providerFax);

      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const {
        Name,
        Address,
        City,
        State,
        Zip,
        PhoneNumber,
        BirthDate,
      } = this.user;

      this.item.employeeName = Name;
      this.item.address = Address;
      this.item.city = City;
      this.item.state = State;
      this.item.zip = Zip;
      this.item.phone = PhoneNumber;
      this.item.birthDate = BirthDate;

      const response = await this.getDocuments(this.user._id);
      const chckDSPD = localStorage.getItem('isChkDSPD');
      const chckDSAMH = localStorage.getItem('isChkDSAMH');
      const chckNaturalSupports = localStorage.getItem('isChkNaturalSupports');
      const chckTTW = localStorage.getItem('isChkTTW');
      const chckPrivatePay = localStorage.getItem('isChkPrivatePay');
      const chckWaitlist = localStorage.getItem('isChkWaitlist');
      const chckApplicant = localStorage.getItem('isChkApplicantDSPD');
      const chckWaiver = localStorage.getItem('isChkWaiver');
      const chckNotEligible = localStorage.getItem('isChkNotEligible');
      const chckActivities = localStorage.getItem('isChkActivities');
      const chckCommunication = localStorage.getItem('isChkCommunication');
      const chckEconomic = localStorage.getItem('isChkEconomic');
      const chckJudgement = localStorage.getItem('isChkJudgement');
      const chckMemory = localStorage.getItem('isChkMemory');
      const chckPhysical = localStorage.getItem('isChkPhysical');
      const chckSelfCare = localStorage.getItem('isChkSelfCare');
      const chckCapacity = localStorage.getItem('isChkCapacity');
      const chckControl = localStorage.getItem('isChkControl');
      const chckEmployment = localStorage.getItem('isChkEmployment');
      const chckLearning = localStorage.getItem('isChkLearning');
      const chckMobility = localStorage.getItem('isChkMobility');
      const chckReceptive = localStorage.getItem('isChkReceptive');
      const chckSelfDirection = localStorage.getItem('isChkSelfDirection');
      const chckBehavioral = localStorage.getItem('isChkBehavioral');
      const chckDayProgram = localStorage.getItem('isChkDayProgram');
      const chckSupported = localStorage.getItem('isChkSupported');
      const chckTransportation = localStorage.getItem('isChkTransportation');
      const chckFacility = localStorage.getItem('isChkFacilityBasedWork');
      const chckInHome = localStorage.getItem('isChkInHome');
      const providerinfo = localStorage.getItem('providerInfo');
      const chckRespite = localStorage.getItem('isChkRespite');
      const chckFamilySupport = localStorage.getItem('isChkFamilySupport');
      const chckSupportedLiving = localStorage.getItem('isChkSupportedHomeLiving');
      const chckAfterSchool = localStorage.getItem('isChkAfterSchool');
      const chckResidential = localStorage.getItem('isChkResidential');
      const residentialinfo = localStorage.getItem('residentialInfo');
      const chck24hour = localStorage.getItem('isChk24Hour');
      const chckProfessionalParent = localStorage.getItem('isChkProfessionalParent');
      const chckResidentialSupport = localStorage.getItem('isChkSupportedResidentialLiving');
      const chckOther = localStorage.getItem('isChkOther');
      const specifyInOther = localStorage.getItem('specify');
      const dspdemail = localStorage.getItem('dspdEmail');
      const dspdtitle = localStorage.getItem('dspdTitle');
      const dspdphone = localStorage.getItem('dspdPhone');
      const othersupport = localStorage.getItem('otherSupportProvider');
      const extendedsupport = localStorage.getItem('extendedSupports');
      const ipsrepresentative = localStorage.getItem('ipsRepresentative');
      const ipsemail = localStorage.getItem('ipsEmail');
      const ipsphone = localStorage.getItem('ipsPhone');
      const sentvia = localStorage.getItem('rbIsChkVia');
      const vrcounselorname = localStorage.getItem('vrCounselorName');
      const provideremail = localStorage.getItem('providerEmail');
      const providerphone = localStorage.getItem('providerPhone');
      const providerdfax = localStorage.getItem('providerFax');

      if (chckDSPD !== null) {
        this.isChkDSPD = chckDSPD;
      }
      if (chckDSAMH !== null) {
        this.isChkDSAMH = chckDSAMH;
      }
      if (chckNaturalSupports !== null) {
        this.isChkNaturalSupports = chckNaturalSupports;
      }
      if (chckTTW !== null) {
        this.isChkTTW = chckTTW;
      }
      if (chckPrivatePay !== null) {
        this.isChkPrivatePay = chckPrivatePay;
      }
      if (chckWaitlist !== null) {
        this.isChkWaitlist = chckWaitlist;
      }
      if (chckApplicant !== null) {
        this.isChkApplicantDSPD = chckApplicant;
      }
      if (chckWaiver !== null) {
        this.isChkWaiver = chckWaiver;
      }
      if (chckNotEligible !== null) {
        this.isChkNotEligible = chckNotEligible;
      }
      if (chckActivities !== null) {
        this.isChkActivities = chckActivities;
      }
      if (chckCommunication !== null) {
        this.isChkCommunication = chckCommunication;
      }
      if (chckEconomic !== null) {
        this.isChkEconomic = chckEconomic;
      }
      if (chckJudgement !== null) {
        this.isChkJudgement = chckJudgement;
      }
      if (chckMemory !== null) {
        this.isChkMemory = chckMemory;
      }
      if (chckPhysical !== null) {
        this.isChkPhysical = chckPhysical;
      }
      if (chckSelfCare !== null) {
        this.isChkSelfCare = chckSelfCare;
      }
      if (chckCapacity !== null) {
        this.isChkCapacity = chckCapacity;
      }
      if (chckControl !== null) {
        this.isChkControl = chckControl;
      }
      if (chckEmployment !== null) {
        this.isChkEmployment = chckEmployment;
      }
      if (chckLearning !== null) {
        this.isChkLearning = chckLearning;
      }
      if (chckMobility !== null) {
        this.isChkMobility = chckMobility;
      }
      if (chckReceptive !== null) {
        this.isChkReceptive = chckReceptive;
      }
      if (chckSelfDirection !== null) {
        this.isChkSelfDirection = chckSelfDirection;
      }
      if (chckBehavioral !== null) {
        this.isChkBehavioral = chckBehavioral;
      }
      if (chckDayProgram !== null) {
        this.isChkDayProgram = chckDayProgram;
      }
      if (chckSupported !== null) {
        this.isChkSupported = chckSupported;
      }
      if (chckTransportation !== null) {
        this.isChkTransportation = chckTransportation;
      }
      if (chckFacility !== null) {
        this.isChkFacilityBasedWork = chckFacility;
      }
      if (chckInHome !== null) {
        this.isChkInHome = chckInHome;
      }
      if (providerinfo !== null) {
        this.providerInfo = providerinfo;
      }
      if (chckRespite !== null) {
        this.isChkRespite = chckRespite;
      }
      if (chckFamilySupport !== null) {
        this.isChkFamilySupport = chckFamilySupport;
      }
      if (chckSupportedLiving !== null) {
        this.isChkSupportedHomeLiving = chckSupportedLiving;
      }
      if (chckAfterSchool !== null) {
        this.isChkAfterSchool = chckAfterSchool;
      }
      if (chckResidential !== null) {
        this.isChkResidential = chckResidential;
      }
      if (residentialinfo !== null) {
        this.residentialInfo = residentialinfo;
      }
      if (chck24hour !== null) {
        this.isChk24Hour = chck24hour;
      }
      if (chckProfessionalParent !== null) {
        this.isChkProfessionalParent = chckProfessionalParent;
      }
      if (chckResidentialSupport !== null) {
        this.isChkSupportedResidentialLiving = chckResidentialSupport;
      }
      if (chckOther !== null) {
        this.isChkOther = chckOther;
      }
      if (specifyInOther !== null) {
        this.specify = specifyInOther;
      }
      if (dspdemail !== null) {
        this.dspdEmail = dspdemail;
      }
      if (dspdtitle !== null) {
        this.dspdTitle = dspdtitle;
      }
      if (dspdphone !== null) {
        this.dspdPhone = dspdphone;
      }
      if (othersupport !== null) {
        this.otherSupportProvider = othersupport;
      }
      if (extendedsupport !== null) {
        this.extendedSupports = extendedsupport;
      }
      if (ipsrepresentative !== null) {
        this.ipsRepresentative = ipsrepresentative;
      }
      if (ipsemail !== null) {
        this.ipsEmail = ipsemail;
      }
      if (ipsphone !== null) {
        this.ipsPhone = ipsphone;
      }
      if (sentvia !== null) {
        this.rbIsChkVia = sentvia === 'true' ? true : false;
      }
      if (vrcounselorname !== null) {
        this.vrCounselorName = vrcounselorname;
      }
      if (provideremail !== null) {
        this.providerEmail = provideremail;
      }
      if (providerphone !== null) {
        this.providerPhone = providerphone;
      }
      if (providerdfax !== null) {
        this.providerFax = providerdfax;
      }

      if (response.data.document != null) {
        let documents = this.updateCase(
          response.data.document.Documents.ConfirmationExtendedService
        );

        this.item = Object.assign(
          {},
          {
            ...documents,
            employeeName: response.data.document.Employee.Name,
            ipsDate: moment(documents.ipsDate).format("YYYY-MM-DD"),
            dateSent: moment(documents.dateSent).format("YYYY-MM-DD"),
            dspdRepresentativeDate: moment(
              documents.dspdRepresentativeDate
            ).format("YYYY-MM-DD"),
          }
        );
      }
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "confirmation-extended-service",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(pdfFile, "confirmation-extended-service.pdf", "application/pdf");
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.v-stepper__content {
  top: 0;
  padding: 0 !important;
  flex: 1 0 auto;
  width: 100%;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
